import {Component, OnInit, Input} from '@angular/core';
// import {Player} from "../player";
import {TopListRow} from "../top-list-row";
import {TopListService} from "../top-list.service";
import {Router} from "@angular/router";
import {AuthService} from "../auth.service";
import {QuizService} from "../quiz.service";
import {Quiz} from "../quiz";
import {PlayerService} from "../player.service";
import {PlayersAnswer} from "../players-answer";

@Component({
  selector: 'app-top-list',
  templateUrl: './top-list.component.html',
  styleUrls: ['./top-list.component.css']
})
export class TopListComponent implements OnInit {

  public toplistrows: TopListRow[] = null;
  public quizzes: Quiz[] = null;
  public answers: PlayersAnswer[] = null;

  @Input() authorized: boolean;

  constructor(private topListService: TopListService,
              private quizService: QuizService,
              private playerService: PlayerService,
              private router: Router,
              private authService: AuthService) {
    topListService.currentList$.subscribe(newList => this.toplistrows = newList);
    quizService.quizzes$.subscribe(quizzes => this.quizzes = quizzes.sort((a, b) => {
      if (a.quizName_fi < b.quizName_fi) {
        return -1;
      }
      if (a.quizName_fi > b.quizName_fi) {
        return 1;
      }
      return 0;
    }));
    playerService.answers$.subscribe(answers => this.answers = answers);
    this.topListService.refresh();
  }

  ngOnInit() {
    this.authorized = this.authService.isLoggedIn() != null;
  }

  public doesQuizHaveAnswers(quiz: Quiz) {

    if (!this.answers || this.answers.length == 0) { return false; }

    for (let answer of this.answers) {
      if(quiz.questionArray.includes(answer.questionID)) return true;
    }
    return false;
  }

  public isRowInQuiz(row: TopListRow, quiz: Quiz) {
    for (let answer of this.answers) {
      if (row._id === answer.playerID) {
        if (quiz.questionArray.includes(answer.questionID)) {
          return true;
        }
      }
    }
    return false;
  }


  public expandCollapseTable() {
    var x = document.getElementById("table");
    if (x.style.display === "none") {
      x.style.display = "table";
    } else {
      x.style.display = "none";
    }
  }

  public edit(playerID: string) {
    this.router.navigate(['/admin/players/', playerID]);
  }

  public refreshList() {
    this.topListService.refresh();
  }
}



// WEBPACK FOOTER //
// ./src/app/top-list/top-list.component.ts